<template>
  <b-container fluid>
    <b-row>
      <b-col  v-if="dataLoaded" sm="12">
        <b-row class="my-1">
          <b-col sm="3">
            <label>Name</label>
          </b-col>
          <b-col sm="9">
            <b-form-input type="text" v-model="predictionConfig.name">Test</b-form-input>
            <span>The name of the prediction config. Will also be used for the file name. No need to include <strong>.json</strong></span>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="3">
            <label>Score Type</label>
          </b-col>
          <b-col sm="9">
            <b-form-input type="text" v-model="predictionConfig.scoreType"></b-form-input>
            <span>Whether to weight score based on margin or position. Options: <strong>marginScore</strong> or <strong>score</strong></span>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="3">
            <label>Race Properties</label>
          </b-col>
          <b-col sm="9">
            <b-row v-for="prop in predictionConfig.raceProperties" class="my-1">
            <b-col sm="10">
              <b-form-input type="text" v-model="prop.propertyName">{{prop.propertyName}}</b-form-input>
            </b-col>
            <b-col sm="2">
              <b-form-input type="number" v-model="prop.weight">{{prop.weight}}</b-form-input>
            </b-col>
            </b-row>
            <span>Properties to use when scoring, including weighting</strong></span>
            <br>
            <i v-on:click="newRaceProperty()" class="material-icons md-24 clickable">add_circle</i>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="3">
            <label>Excluded Tags</label>
          </b-col>
          <b-col sm="9">
            <b-form-input type="text" v-model="predictionConfig.excludedTagsString"></b-form-input>
            <span>List of tags to be excluded, comma separated. E.g. <strong>007,008,014</strong></span>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="3">
            <label>Exclude Outsiders</label>
          </b-col>
          <b-col sm="1">
            <b-form-checkbox
              id="checkbox-1"
              v-model="predictionConfig.excludeOutsiders"
              name="checkbox-1">
            </b-form-checkbox>
          </b-col>
          <b-col sm="7">
            <span>Whether to include outsiders (horses with odds > number of runners) or exclude them from predictions</span>
          </b-col>
        </b-row >
        <b-row class="my-1">
          <b-col sm="3">
            <label>Allow 0 Score For Property Values</label>
          </b-col>
          <b-col sm="1">
            <b-form-checkbox
              id="checkbox-2"
              v-model="predictionConfig.allow0ScoreForPropertyValues"
              name="checkbox-2">
            </b-form-checkbox>
          </b-col>
          <b-col sm="7">
            <span>If a score for the race property is 0, include is (i.e. it will bring down the average) or ignore it</span>
          </b-col>
        </b-row >
        <b-row class="my-1">
          <b-col sm="3">
            <label>Use extreme scores</label>
          </b-col>
          <b-col sm="2">
            <b-form-input type="number" v-model="predictionConfig.useExtremeScoresOnly.top"></b-form-input>
            <span>Top</span>
          </b-col>
          <b-col sm="2">
            <b-form-input type="number" v-model="predictionConfig.useExtremeScoresOnly.bottom"></b-form-input>
            <span>Bottom</span>
          </b-col>
        </b-row >
        <b-row class="my-1">
          <b-col sm="3">
            <label>Threshold</label>
          </b-col>
          <b-col sm="2">
            <b-form-input type="number" v-model="predictionConfig.threshold.number"></b-form-input>
          </b-col>
          <b-col sm="7" align-h="start">
            <span>Whether to ignore tag scores (for a race property) that are below this number</span>
          </b-col>
        </b-row >
        <b-row class="my-1">
          <b-col sm="3">
            <label>Threshold Weighting</label>
          </b-col>
          <b-col sm="2">
            <b-form-input type="number" v-model="predictionConfig.thresholdWeighting.threshold"></b-form-input>
            <span>Threshold</span>
          </b-col>
          <b-col sm="2">
            <b-form-input type="number" v-model="predictionConfig.thresholdWeighting.weight"></b-form-input>
            <span>Weight</span>
          </b-col>
        </b-row >
        <b-button class="top-margin" v-on:click="updateConfig()">{{updateButtonText}}</b-button>
        <b-row class="my-1" v-if="showPasswordInput" >
          <b-col sm="12">
            <b-form-input id="configPassword" class="passwordInput" v-model="password" type="password" placeholder="Please enter password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1" v-if="showAlert">
          <b-col sm="12">
            <b-alert show variant="danger">Password incorrect</b-alert>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import PredictionConfig from '../models/PredictionConfig'
export default {
  name: 'PredictionConfigEditor',
  props: ['predictionConfigName'],
  components: {},
  data () {
    return {
      dataLoaded: false,
      predictionConfig: {},
      updateButtonText: "Update",
      showPasswordInput: false,
      password:"",
      showAlert: false
    }
  },
  methods: {
    updateConfig: function() {
      this.showAlert = false
      console.log(this.predictionConfig)
      if (!this.predictionConfig.name) {

      }else {
        if (this.updateButtonText === "Update") {
          this.updateButtonText = "Confirm"
          this.showPasswordInput = true
        }else {
          return this.predictionConfig.save(this.password)
          .then(response => {
            this.updateButtonText = "Update"
            this.showPasswordInput = false
            this.$router.push({name:'PredictionConfig',params:{configId:this.predictionConfig.name}})
          })
          .catch (err => {
            console.log(err)
            if (err.response.status === 403) {
              this.showAlert = true
            }
          })
        }
      }
    },
    newRaceProperty: function() {
      this.predictionConfig.raceProperties.push({propertyName:""})
    },
    reloadConfig: function() {
      var configName = this.$route.params.configId
      if (configName) {
        if (configName === 'new') configName = undefined
        this.predictionConfig = new PredictionConfig(configName)
        if (configName){
          return this.predictionConfig.load()
          .then(response => {
            this.dataLoaded = true
          })
        }else {
          this.dataLoaded = true
        }
      }else {
        this.dataLoaded = false
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === "PredictionConfig") this.reloadConfig()
    }
  },
  mounted () {
    this.reloadConfig()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}

.passwordInput {
  display: inline-block;
  max-width: 40%;
}

label {
  text-align: center;
}

span {
  color: #FFFFFF96
}

.top-margin {
  margin-top: 10px
}
</style>
